import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DownloadIcon, X } from "lucide-react";

const animation = {
  hide: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

function ResumeSection() {
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef();

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="flex flex-col items-center justify-center mt-10">
      <motion.h2
        className="mb-4 text-xl md:text-2xl font-semibold text-[#7000ff] dark:text-[#7000ff]"
        initial={animation.hide}
        animate={animation.show}
      >
        Resume
      </motion.h2>

      {/* Resume Preview */}
      <motion.div
        onClick={() => setIsOpen(true)}
        className="cursor-pointer w-full max-w-4xl aspect-video rounded-xl overflow-hidden border border-gray-300 dark:border-gray-600 shadow-lg"
        initial={animation.hide}
        animate={animation.show}
      >
        <iframe
          src="/Resume_AnthonyTran.pdf"
          title="Resume Preview"
          className="w-full h-full pointer-events-none"
          frameBorder="0"
        />
      </motion.div>

      {/* Download Button */}
      <motion.a
        href="/Resume_AnthonyTran.pdf"
        download
        className="mt-6 inline-flex items-center gap-2 px-4 py-2 bg-[#7000ff] text-white rounded-lg hover:bg-[#5e00cc] transition-colors"
        initial={animation.hide}
        animate={animation.show}
        transition={{ delay: 0.7 }}
      >
        <DownloadIcon className="w-5 h-5" />
        Download Resume
      </motion.a>

      {/* Modal */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              ref={modalRef}
              className="relative w-[95%] h-[90%] bg-white rounded-xl overflow-hidden shadow-2xl"
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
            >
              {/* Close Button */}
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-4 right-4 text-gray-700 hover:text-black z-10"
              >
                <X className="w-10 h-10" />
              </button>
              {/* Full Resume */}
              <iframe
                src="/Resume_AnthonyTran.pdf"
                title="Resume Full View"
                className="w-full h-full"
                frameBorder="0"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default ResumeSection;
